export const centsToDollars = (cents: number, decimals = 2): number => {
  return parseInt(Number(cents * 0.01).toFixed(decimals));
};

export const handleErrorLogging = (error: Error) => {
  // Future use for error logging on third party tool (e.g. Sentry - https://docs.sentry.io/platforms/javascript/)
  console.error(error);
};
